export default {
  state: {
    fbmessagechat: {}
  },
  mutations: {
    SET_FBMessageChat: (state, roles) => {
      state.fbmessagechat = roles;
    }
  },
  actions: {
    setfbmessagechat({ commit }, value) {
      commit('SET_FBMessageChat', value);
    }
  }
};
